import React from 'react';
import { CContainer, CRow, CCol } from '@coreui/react';

const DownloadSection = () => {
  return (
    <>
      <style>{`
        /* APP DOWNLOAD SECTION */
        .section-app-download.call-to-action {
          position: relative;
          z-index: 0;
          overflow: hidden;
          padding: 60px 0;
        }

        .ds-cta-container {
          color: #ffffff;
          position: relative;
          overflow: visible !important;
          border-radius: 2rem;
          padding: 4rem 2rem;
          z-index: 1;
          background: linear-gradient(to right, #A3CFBB);
        }

        /* Desktop Input */
        @media (min-width: 992px) {
          .download-input-wrapper {
            display: flex;
            align-items: center;
            border: 2px solid #000000 !important;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 60px;
            padding: 6px 6px 6px 20px;
            max-width: 480px;
            position: relative;
            z-index: 5;
          }

          .custom-input {
            border: none !important;
            background: transparent !important;
            color: #000000 !important;
            outline: none;
            flex-grow: 1;
            font-size: 16px;
          }

          .custom-submit-btn {
            background-color: transparent !important;
            color: #000000 !important;
            border: 2px solid #000000 !important;
            padding: 12px 35px;
            border-radius: 50px;
            font-weight: 700;
            white-space: nowrap;
            transition: all 0.3s ease;
            cursor: pointer;
          }

          .ds-justify-start {
            justify-content: flex-start !important;
          }
        }

        /* Mobile Input */
        @media (max-width: 991px) {
          .ds-cta-container {
            text-align: center;
            padding: 3rem 1.5rem;
          }

          .download-input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 15px;
            background: transparent !important;
            border: none !important;
            max-width: 100%;
          }

          .custom-input {
            background: rgba(255, 255, 255, 0.15) !important;
            border: 2px solid #ffffff !important;
            border-radius: 50px;
            padding: 15px 20px;
            color: white !important;
            text-align: center;
            width: 100%;
            outline: none;
          }

          .custom-submit-btn {
            background-color: transparent !important;
            color: #000000 !important;
            border: 2px solid #000000 !important;
            padding: 12px 35px;
            border-radius: 50px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .app-screen-img {
            max-width: 250px;
            margin: 20px auto 0;
            display: block;
          }

          .ds-justify-start {
            justify-content: center !important;
          }
        }

        .custom-input::placeholder {
          color: rgba(0, 0, 0, 0.5) !important;
        }

        .custom-submit-btn:hover {
          background-color: #000000 !important;
          color: #ffffff !important;
          transform: translateY(-3px);
        }

        .app-download-img {
          height: 45px;
          width: auto;
          transition: transform 0.3s ease;
          cursor: pointer;
        }

        .app-download-img:hover {
          transform: scale(1.1);
        }

        .app-screen-img {
          height: 330px;
          width: auto;
          object-fit: contain;
        }
      `}</style>

      <section className="section-app-download call-to-action py-0">
        <CContainer className="ds-cta-container mt-0">
          <CContainer>
            <CRow
              className="align-items-center position-relative"
              style={{ zIndex: 5 }}
            >
              {/* Left Side */}
              <CCol md={6} className="content text-dark">
                <h2>Download the Medisevas App</h2>
                <p>
                  Access video consultations with India's top doctors 24/7,
                  right from the comfort of your home.
                </p>

                <div className="download-input-wrapper mt-4">
                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Enter Mobile Number"
                  />
                  <button className="custom-submit-btn">Send Link</button>
                </div>

                <div className="d-flex gap-3 mt-4 ds-justify-start">
                  <img
                    src="assets/img/google_play.png"
                    className="app-download-img"
                    alt="Google Play"
                  />
                  <img
                    src="assets/img/apple_store.png"
                    className="app-download-img"
                    alt="App Store"
                  />
                </div>
              </CCol>

              {/* Right Side */}
              <CCol md={6} className="text-center text-md-end mt-5 mt-md-0">
                <img
                  src="assets/img/features/Download1.png"
                  className="img-fluid app-screen-img"
                  alt="App"
                  style={{
                    height: '330px',
                    width: 'auto',
                    objectFit: 'contain',
                  }}
                />
              </CCol>
            </CRow>
          </CContainer>
        </CContainer>
      </section>
    </>
  );
};

export default DownloadSection;